export default "__VITE_ASSET__ByeGx$Qq__"